import { OrderSummaryData } from '@/types';
import { Core, ORDER_SUMMARY } from '../Core';

class Order extends Core {
  getOrderSummary = async () => this.get<OrderSummaryData>(ORDER_SUMMARY());
}

export const order = new Order();
